import { ApolloError } from '@apollo/client';

export const getListsFeatureDisabledResponse = (resultErrs: ApolloError['graphQLErrors']) => {
  // this finds the specific error that is returned if the lists feature
  // has been revoked from the user's company organization
  return resultErrs?.find((e) => {
    return (e?.extensions?.exception as any)?.data?.message === 'Lists are not enabled for this organization';
  });
};
